import React from 'react';
import { Link } from 'react-router-dom';

function MenuItemSidebarLink({
  path, active, onClick, icon, title, haveChildren,
}) {
  return (
    <Link
      to={path}
      className={`sidebar-header ${active ? 'active' : ''}`}
      onClick={onClick}
    >
      {icon}
      <span>{title}</span>
      {haveChildren && <i className="fa fa-angle-right pull-right" />}
    </Link>
  );
}

MenuItemSidebarLink.propTypes = {};

export default MenuItemSidebarLink;
